import { Link } from 'react-router-dom';
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Icon, Intent, Alert, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import Clearfix from 'components/elements/clearfix';
import SearchContainer from './SearchContainer';
import FormSearchType1Container from './FormSearchType1Container';
import Message from 'rc-message';

import { get as _get } from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import slug from 'constants/slug';
import ItemPerPageSelect from 'components/elements/select-itemPerPage';
import Pagination from 'rc-pagination';
import localeInfo from 'rc-pagination/lib/locale/en_US';
import PropTypes from 'prop-types';
import Permissions from 'react-redux-permissions';
import { COLOR } from 'config';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const SpinnerContainer = styled.div`
  margin: 100px auto;
  //width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
`;

const PaginationContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const TotalContainer = styled.div`
  .rc-pagination-item,
  .rc-pagination-prev,
  .rc-pagination-next {
    display: none;
  }
`;

const BootstrapTableWrapper = styled.div`
  div {
    .children-td tr {
      display: flex
    }

    .child {
      padding: 0
      flex: 1
    }

    .table tr:nth-child(1) th.child-column {
      min-width: 90px
      max-width: 90px
      padding: 0
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical; 
      overflow: hidden;
    }

    .table tr:nth-child(1) th.child {
      background: #f2f2f2 !important;
    }
  
    .table-hover tbody tr:hover .child {
      background: #eeeeee !important;
    }
  
    .table-striped tbody tr:nth-of-type(even) .child {
      background: #ffffff !important;
    }
  
    .table-striped tbody tr:nth-of-type(even):hover .child {
      background: #eeeeee !important;
    }
  }
`;
export class BaseListContainer extends React.Component {
  static propTypes = {
    hideRightHeaderContent: PropTypes.bool,
    form: PropTypes.object,
  };

  constructor(
    props,
    funcApi = {},
    columns = [],
    createPath = slug.BASE,
    moduleName = '',
    fixSearch = {}, // fix Search theo bien truyen vao
    hideAdd = false,
    isDisable_FacilityParent = false,
    hideExportBtn = false,
    placeholderSearch = null
  ) {
    super(props);
    this.state = {
      isLoading: true,
      dataList: [],
      valueSearch: {},
      pagination: {
        page: 1,
        minIndex: 0,
        maxIndex: 5,
        itemPerPage: 10,
        totalItem: 0,
      },
      isOpenExport: false,
      fixSearch: fixSearch,
      hideAdd: hideAdd,
    };

    this.options = {
      page: this.state.pagination.page, // which page you want to show as default
      sizePerPage: this.state.pagination.itemPerPage, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      prePage: 'Prev', // Previous page button text
      nextPage: 'Next', // Next page button text
      firstPage: 'First', // First page button text
      lastPage: 'Last', // Last page button text
      paginationShowsTotal: true, // Accept bool or function
      paginationPosition: 'top', // default is bottom, top and both is all available
      alwaysShowAllBtns: true,
      hideSizePerPage: true,
      onPageChange: this.onPageChange,
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button
    };
    this.funcApi = funcApi;
    this.columns = columns;
    this.createPath = createPath;
    this.mounted = true;
    this.moduleName = moduleName;
    this.isDisable_FacilityParent = isDisable_FacilityParent;
    this.hideExportBtn = hideExportBtn;
    this.placeholderSearch = placeholderSearch;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handelSubmitSearch(values) {
    this.setState(
      {
        isLoading: true,
        valueSearch: _.pickBy(values, _.identity),
        pagination: {
          ...this.state.pagination,
          page: 1,
        },
      },
      () => {
        this.fetData();
      }
    );
  }

  fetData = async () => {
    if (!this.funcApi.getList) {
      this.setState({ isLoading: false });
      return;
    }
    // console.log('getList',this.state.valueSearch, this.state.fixSearch )

    const res = await this.funcApi.getList({
      ...this.state.pagination,
      ...this.state.valueSearch,
      ...this.state.fixSearch,
    });

    if (_get(res, 'success', false) && this.mounted) {
      // console.log(JSON.stringify(res, null, 2));
      this.setState({
        dataList: _get(res, 'data', []),
        pagination: _get(res, 'pagination', []),
        isLoading: false,
      });
    }
  };

  onPageChange = async (current, pageSize) => {
    this.setState(
      {
        isLoading: true,
        pagination: {
          ...this.state.pagination,
          page: current,
        },
      },
      () => {
        this.fetData();
      }
    );
  };

  componentWillMount() {
    this.fetData();
  }

  renderHeaderContainer() {
    this.options = {
      ...this.options,
      page: _get(this.state.pagination, 'page', null),
      sizePerPage: _get(this.state.pagination, 'itemPerPage', null),
    };

    return (
      <HeaderContainer>
        <div style={{ display: 'inline-flex' }}>
          <Permissions allowed={[`${this.moduleName}.write`]}>
            {!this.state.hideAdd && (
              <Fragment>
                <Link to={this.createPath}>
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.ADD}
                    iconSize={Icon.SIZE_LARGE}
                  />
                </Link>

                <Clearfix width={8} />
                <Link to={this.createPath}>
                  <h5
                    style={{
                      color: COLOR.PRIMARY_COLOR,
                      cursor: 'pointer',
                      textDecoration: 'underline',
                    }}
                    className='bp3-heading'
                  >
                    Thêm mục mới
                  </h5>
                </Link>
              </Fragment>
            )}
          </Permissions>
        </div>
        {!this.props.hideRightHeaderContent && (
          <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <div style={{ width: 300 }}>
              {' '}
              <ItemPerPageSelect
                onChange={(selectedOption) => {
                  if (selectedOption && selectedOption.value)
                    this.setState(
                      {
                        pagination: {
                          ...this.state.pagination,
                          itemPerPage: selectedOption.value,
                          page: 1,
                        },
                      },
                      () => this.fetData()
                    );
                }}
              />
            </div>
            <Clearfix width={8} />
            {!this.hideExportBtn && (
              <Icon
                icon={IconNames.EXPORT}
                iconSize={Icon.SIZE_LARGE}
                className='pointer'
                intent={Intent.SUCCESS}
                style={{ color: COLOR.SUCCESS }}
                // onClick={this.funcApi.exportData}
                onClick={async () => {
                  this.setState({ isOpenExport: true });

                  let res = await this.funcApi.exportData({
                    ...this.state.valueSearch,
                  });
                  // console.log(res);
                  if (_.get(res, 'error') === true) {
                    Message.error({
                      content: 'xuất excel không thực hiện được',
                    });
                    this.setState({ isOpenExport: false });
                  } else {
                    let dataBuff = toArrayBuffer(res.buffer.data);
                    let blob = new Blob([dataBuff], {
                      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    getFile(blob, res.fileName);
                  }
                }}
              />
            )}
          </div>
        )}

        <Alert
          // {...alertProps}
          // className={this.props.data.themeName}
          confirmButtonText='Cancel'
          isOpen={this.state.isOpenExport}
          onClose={() => {
            this.setState({ isOpenExport: false });
          }}
        >
          <div id='downloadlink'>Export.....</div>
        </Alert>
      </HeaderContainer>
    );
  }

  renderSearchContainer() {
    const form = this.props.form;
    // console.log(this.props.typeSearch, '==this.props.typeSearch')

    switch (this.props.typeSearch) {
      case 'form_2': {
        return (
          <div>
            {!this.props.hideRightHeaderContent && form && (
              <div>
                <FormSearchType1Container
                  form={form}
                  handelSubmitSearch={this.handelSubmitSearch.bind(this)}
                  expand={
                    this.props.isShowExpandSearch &&
                    this.renderSearchExpandContainer ? (
                      this.renderSearchExpandContainer()
                    ) : (
                      <React.Fragment></React.Fragment>
                    )
                  }
                />
              </div>
            )}
          </div>
        );
      }
      default: {
        return (
          <div>
            {!this.props.hideRightHeaderContent && form && (
              <div>
                <SearchContainer
                  moduleName={this.moduleName}
                  isDisable_FacilityParent={this.isDisable_FacilityParent}
                  form={form}
                  handelSubmitSearch={this.handelSubmitSearch.bind(this)}
                  placeholderSearch={this.placeholderSearch}
                  expand={
                    this.props.isShowExpandSearch &&
                    this.renderSearchExpandContainer ? (
                      this.renderSearchExpandContainer()
                    ) : (
                      <React.Fragment></React.Fragment>
                    )
                  }
                />
              </div>
            )}
          </div>
        );
      }
    }
  }

  renderSpinnerNodata = () => {
    return (
      <SpinnerContainer>
        {this.state.isLoading ? <Spinner size={100} /> : <h2>No Data</h2>}
      </SpinnerContainer>
    );
  };

  customTotal = (from, to, size) => (
    <span className='react-bootstrap-table-pagination-total'>
      Showing {from} to {to} of {size} Results
    </span>
  );

  rowClasses = (row, rowIndex) => {
    if (this.state.isLoading) return 'bp3-skeleton-row';
    return '';
  };

  renderDataTable() {
    const { pagination } = this.state;
    return (
      <div style={{ overflowX: 'auto' }}>
        <BootstrapTableWrapper>
          <BootstrapTable
            keyField='_id'
            data={this.state.dataList}
            columns={this.columns}
            striped
            hover
            remote
            loading={this.state.isLoading}
            rowClasses={this.rowClasses}
            noDataIndication={this.renderSpinnerNodata}
          />
        </BootstrapTableWrapper>

        <PaginationContainer>
          <TotalContainer>
            {this.state.pagination.totalItem > 0 && (
              <Pagination
                pageSize={pagination.itemPerPage}
                showPrevNextJumpers={false}
                onChange={this.onPageChange}
                current={pagination.page}
                total={pagination.totalItem}
                showTotal={(total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} Results`
                }
              />
            )}
          </TotalContainer>

          <Pagination
            hideOnSinglePage
            pageSize={pagination.itemPerPage}
            showQuickJumper
            onChange={this.onPageChange}
            current={pagination.page}
            total={pagination.totalItem}
            locale={{
              ...localeInfo,
              jump_to: 'Go to',
            }}
          />
        </PaginationContainer>
      </div>
    );
  }

  render() {
    return (
      <div style={{ width: '100%' }}>
        {this.renderHeaderContainer()}
        <Clearfix height={8} />
        {this.renderSearchContainer()}
        <Clearfix height={8} />
        {this.renderDataTable()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BaseContainer/BaseListContainer.js